/**
 * @author Kovács Vince <vincekovacs@hotmail.com>
 */
(function ($, undefined) {
    "use strict"

    /**
     * @param {jQuery} element
     * @param {object} options
     * @constructor
     */
    function TokenInput (element, options) {
        /**
         * @type {jQuery}
         */
        this.element = element
        /**
         * @type {Options~TokenInput}
         */
        this.options = $.extend(true, {}, $.fn.tokenInput.options, options)

        /**
         * @type {?jQuery}
         */
        this.selected = null

        this.ajax = {
            timeout: null,
            lastRequest: null
        }

        /**
         * @type {string}
         */
        this.search = ""

        /**
         * @type {{container: {?jQuery}, tokenList: {?jQuery}, tokenInput: {?jQuery}, dropdown: {?jQuery}}}
         */
        this.dom = {
            container: null,
            tokenList: null,
            tokenInput: null,
            dropdown: null
        }

        this.init()
    }

    /**
     * @param {string} str
     * @returns {string}
     */
    function escapeRegExp (str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&")
    }

    /**
     * @param {TokenInput} tokenInput
     */
    function save (tokenInput) {
        var data = []
        tokenInput.dom.tokenList.find(".token-list-item").each(function () {
            data.push($(this).data("item")[tokenInput.options.valueProperty])
        })

        tokenInput.element.val(data.join(tokenInput.options.separator))
    }

    /**
     * @param {TokenInput} tokenInput
     * @param {Item~TokenInput} item
     */
    function addToken (tokenInput, item) {
        if (tokenInput.options.callback.beforeAdd !== null && tokenInput.options.callback.beforeAdd(item) !== true) {
            return
        }

        $("<li class=\"token-list-item\"/>")
            .addClass(tokenInput.options.classes.tokenItem)
            .html(item[tokenInput.options.displayProperty])
            .data("item", item)
            .click(function () {
                if (tokenInput.options.disabled !== true) {
                    selectToken(tokenInput, $(this))
                }
            })
            .append($("<div class=\"close\"/>")
                .html("&times;")
                .click(function () {
                    removeToken(tokenInput, item[tokenInput.options.valueProperty])
                }))
            .appendTo(tokenInput.dom.tokenList)

        // Hide TokenInput's input element if max token count was reached
        if (tokenInput.options.tokenLimit !== null &&
            tokenInput.dom.tokenList.find(".token-list-item").length >= tokenInput.options.tokenLimit
        ) {
            tokenInput.dom.tokenInput.hide()
        }

        save(tokenInput)

        if (tokenInput.options.callback.onAdd !== null) {
            tokenInput.options.callback.onAdd(item)
        }
    }

    /**
     * @param {TokenInput} tokenInput
     * @param {int|string} value item identifier value
     */
    function removeToken (tokenInput, value) {
        tokenInput.dom.tokenList.find(".token-list-item").each(function (index, element) {
            /**
             * @type {Item~TokenInput}
             */
            var item = $(element).data("item")
            if (item[tokenInput.options.valueProperty] === value) {
                $(element).remove()

                if (tokenInput.options.callback.onRemove !== null) {
                    tokenInput.options.callback.onRemove(item)
                }
            }
        })

        if (tokenInput.options.tokenLimit !== null &&
            tokenInput.dom.tokenList.find(".token-list-item").length < tokenInput.options.tokenLimit
        ) {
            tokenInput.dom.tokenInput.show()
        }

        save(tokenInput)
    }

    /**
     * @param {TokenInput} tokenInput
     * @param {jQuery} element
     */
    function selectToken (tokenInput, element) {
        deselectTokens(tokenInput)

        element.addClass(tokenInput.options.classes.tokenItemSelected)
    }

    /**
     * @param {TokenInput} tokenInput
     */
    function deselectTokens (tokenInput) {
        tokenInput.dom.container.find(".token-list-item").removeClass(tokenInput.options.classes.tokenItemSelected)
    }

    /**
     * @param {TokenInput} tokenInput
     */
    function openDropdown (tokenInput) {
        tokenInput.dom.dropdown.show()
    }

    /**
     * @param {TokenInput} tokenInput
     * @param {string} content
     * @param {boolean} [disabled]
     *
     * @return {jQuery}
     */
    function addDropdownItem (tokenInput, content, disabled) {
        var element = $("<li/>").append(content)

        if (disabled === true) {
            element.addClass("disabled")
        }

        tokenInput.dom.dropdown.append(element)

        return element
    }

    /**
     * @param {TokenInput} tokenInput
     */
    function clearDropdown (tokenInput) {
        tokenInput.dom.dropdown.empty()
    }

    /**
     * @param {TokenInput} tokenInput
     */
    function closeDropdown (tokenInput) {
        clearDropdown(tokenInput)
        tokenInput.dom.tokenInput.find("input").val("")
        tokenInput.dom.dropdown.hide()
    }

    /**
     * @param {TokenInput} tokenInput
     *
     * @return {boolean}
     */
    function isDropdownVisible (tokenInput) {
        return tokenInput.dom.dropdown.is(":visible")
    }

    /**
     * @param {TokenInput} tokenInput
     * @param {string} value
     */
    function loadByIdentifier (tokenInput, value) {
        var identifiers = value.split(tokenInput.options.separator)

        if (tokenInput.options.ajax.url !== null) {
            var data = tokenInput.options.ajax.data
            data[tokenInput.options.ajax.loadParam] = identifiers

            $.ajax(tokenInput.options.ajax.url, {
                method: tokenInput.options.ajax.method,
                data: data,
                dataType: "json",
                success: function (result) {
                    handleIdentifeirLoad(tokenInput, result)
                }
            })
        } else {
            var result = []

            tokenInput.options.data.forEach(function (item) {
                if (identifiers.indexOf(item[tokenInput.options.valueProperty]) > -1) {
                    result.push(item)
                }
            })

            handleIdentifeirLoad(tokenInput, result)
        }
    }

    function handleIdentifeirLoad (tokenInput, data) {
        data.forEach(function (item) {
            addToken(tokenInput, item)
        })
    }

    /**
     * @param {TokenInput} tokenInput
     * @param {string} text
     */
    function search (tokenInput, text) {
        // Nothing to do if search value not changed
        if (tokenInput.search === text) {
            return
        }

        tokenInput.search = text

        clearDropdown(tokenInput)

        if (text.length < tokenInput.options.minChars) {
            addDropdownItem(tokenInput, tokenInput.options.trans.noEnoughDataForSearch, true)
            return
        }

        addDropdownItem(tokenInput, tokenInput.options.trans.searchInProgress, true)

        // Perform search on server side with AJAX
        if (tokenInput.options.ajax.url !== null) {
            if (tokenInput.ajax.timeout !== null) {
                clearTimeout(tokenInput.ajax.timeout)
            }

            // Close last request if not finished
            if (tokenInput.ajax.lastRequest !== null) {
                tokenInput.ajax.lastRequest.abort()
            }

            var data = tokenInput.options.ajax.data
            data[tokenInput.options.ajax.searchParam] = text

            tokenInput.ajax.timeout = setTimeout(function () {
                tokenInput.ajax.timeout = null

                tokenInput.ajax.lastRequest = $.ajax(tokenInput.options.ajax.url, {
                    method: tokenInput.options.ajax.method,
                    data: data,
                    dataType: "json",
                    success: function (result) {
                        handleSearchResult(tokenInput, text, result)
                    },
                    error: function () {
                        clearDropdown(tokenInput)
                        addDropdownItem(tokenInput, tokenInput.options.trans.ajaxError, true)
                    },
                    complete: function () {
                        tokenInput.ajax.lastRequest = null
                    }
                })
            }, tokenInput.options.ajax.searchTimeout)
        }
        // Handle search on client side base on provided static data
        else {
            var result = []

            tokenInput.options.data.forEach(function (item) {
                if (item[tokenInput.options.searchProperty].toLowerCase().indexOf(text.toLowerCase()) > -1) {
                    result.push(item)
                }
            })

            handleSearchResult(tokenInput, text, result)
        }

    }

    /**
     * @param {TokenInput}      tokenInput
     * @param {string}          search
     * @param {Item~TokenInput} result
     */
    function handleSearchResult (tokenInput, search, result) {
        var filteredResultCount = 0

        clearDropdown(tokenInput)

        result.forEach(function (item) {
            var content, value

            if (tokenInput.options.unique === true) {
                var foundMatch = false
                tokenInput.dom.tokenList.find(".token-list-item").each(function (index, element) {
                        var elementItem = $(element).data("item")

                        if (elementItem[tokenInput.options.valueProperty] === item[tokenInput.options.valueProperty]) {
                            foundMatch = true
                        }
                    }
                )

                // Skip if token is already selected
                if (foundMatch) {
                    return
                }
            }

            if (tokenInput.options.callback.formatSearchResultItem !== null) {
                content = tokenInput.options.callback.formatSearchResultItem(item, search)
            } else if (tokenInput.options.resultFormat !== null) {
                content = tokenInput.options.resultFormat
                for (var key in item) {
                    if (item.hasOwnProperty(key)) {
                        value = item[key]
                        if (key === tokenInput.options.searchProperty && tokenInput.options.highlightResultMatch === true) {
                            value = value.replace(new RegExp("(" + escapeRegExp(search) + ")", "ig"), tokenInput.options.highlightResultFormat)
                        }
                        content = content.replace(new RegExp("{{" + key + "}}", "g"), value)
                    }
                }
            } else {
                content = item[tokenInput.options.displayProperty]
                // Allow highlight only if display and search property is match and highlight result is turned on
                if (tokenInput.options.displayProperty === tokenInput.options.searchProperty && tokenInput.options.highlightResultMatch === true) {
                    content = content.replace(new RegExp("(" + escapeRegExp(search) + ")", "ig"), tokenInput.options.highlightResultFormat)
                }
            }

            addDropdownItem(tokenInput, content)
                .on("mouseover", function (e) {
                    tokenInput.dom.dropdown.find("li.active").removeClass("active")
                    $(e.target).addClass("active")
                })
                .on("mousedown", function () {
                    addToken(tokenInput, item)
                    closeDropdown(tokenInput)
                    tokenInput.dom.tokenInput.find("input").focus()
                })

            filteredResultCount++
        })

        // Show result is empty if no result added to result dropdown
        if (filteredResultCount === 0) {
            addDropdownItem(tokenInput, tokenInput.options.trans.resultIsEmpty, true)
        }
    }

    // Avoid Plugin.prototype conflicts
    $.extend(TokenInput.prototype, {
        init: function () {
            var self = this

            // TokenInput work on input only
            if (!this.element.is("input")) {
                console.log("TokenInput cannot work without input field")
                return
            }

            // Load and set data from/for original input
            if (this.options.disabled === null) {
                this.options.disabled = this.element.is(":disabled")
            }
            this.element.hide()

            // Build up token input base DOM structure
            this.dom.container = $("<div class=\"token-list-container\"/>")
                .insertAfter(this.element)

            this.dom.tokenList = $("<ul class=\"token-list-item-container\"/>")
                .addClass(this.options.classes.tokenList)

            this.dom.tokenInput = $("<div class=\"token-list-input-item\"/>")
                .addClass(this.options.classes.tokenInput)
                .append($("<input type=\"text\"/>")
                    .attr("placeholder", self.options.trans.searchInputPlaceholder))
            this.dom.dropdown = $("<ul class=\"token-list-dropdown\"/>")

            $("<div class=\"token-list-controller\"/>")
                .addClass(this.options.classes.core)
                // Selected element container
                .append(this.dom.tokenList)
                // Input field
                .append(this.dom.tokenInput)
                // Result dropdown
                .append(this.dom.dropdown)
                .appendTo(this.dom.container)

            this.disabled(this.options.disabled)

            // Preload data only if field value is empty
            if (this.element.val() === "" || this.options.ajax.loadByIdentifier !== true) {
                // Add preloaded elements into list of selected tokens
                this.options.preloaded.forEach(function (value) {
                    addToken(self, value)
                })
            } else {
                loadByIdentifier(this, this.element.val())
            }

            this.dom.container
                .on("click", function (e) {
                    if (self.options.disabled !== true && $(e.target).hasClass("token-list-controller")) {
                        self.dom.tokenInput.find("input").focus()
                    }
                })
            this.dom.tokenInput.find("input")
                .on("focus", function () {
                    if (!isDropdownVisible(self)) {
                        clearDropdown(self)
                        openDropdown(self)
                        addDropdownItem(self, self.options.trans.noEnoughDataForSearch, true)
                    }
                })
                .on("blur", function () {
                    self.search = ""
                    self.dom.tokenInput.find("input").val("")
                    clearDropdown(self)
                    closeDropdown(self)
                })
                .on("keyup", function (e) {
                    search(self, $(e.target).val())
                })
                .on("keydown", function (e) {
                    var lastActiveItem = self.dom.dropdown.find("li:not(.disabled).active")

                    switch (e.keyCode) {
                        // Enter
                        case 13:
                            e.preventDefault()

                            if (lastActiveItem.length !== 0) {
                                lastActiveItem.mousedown()
                            }
                            break
                        // Up arrow
                        case 38:
                            e.preventDefault()

                            if (lastActiveItem.length === 0) {
                                return
                            }

                            var previousItem = lastActiveItem.prev("li:not(.disabled)")

                            if (previousItem.length > 0) {
                                lastActiveItem.removeClass("active")
                                previousItem.addClass("active")

                                self.dom.dropdown.scrollTop(self.dom.dropdown.scrollTop() + previousItem.position().top + (previousItem.outerHeight(true) - self.dom.dropdown.height()) / 2, 0)
                            }
                            break
                        // Down arrow
                        case 40:
                            e.preventDefault()

                            if (lastActiveItem.length === 0) {
                                self.dom.dropdown.find("li:not(.disabled)").eq(0).addClass("active")
                            } else {
                                var nextItem = lastActiveItem.next("li:not(.disabled)")

                                if (nextItem.length > 0) {
                                    lastActiveItem.removeClass("active")
                                    nextItem.addClass("active")

                                    self.dom.dropdown.scrollTop(self.dom.dropdown.scrollTop() + nextItem.position().top + (nextItem.outerHeight(true) - self.dom.dropdown.height()) / 2, 0)
                                }
                            }
                            break
                    }
                })
        },
        /**
         * Add new element to TokenInput
         *
         * Note: This method not check if TokenInput is disable or not
         *
         * @param {object} item
         */
        add: function (item) {
            addToken(this, item)
        },

        /**
         * Remove element which option's value match with given value
         *
         * @param {int|string} value
         */
        remove: function (value) {
            removeToken(this, value)
        },

        /**
         * Remove all selected tokens
         */
        clear: function () {
            this.dom.tokenList.find(".input-token-item").remove()
        },

        /**
         * Check or set TokenInput disabled status
         *
         * @param {boolean} [disabled]
         *
         * @returns {?boolean} return NULL if new disabled state is set, otherwise actual disabled status
         */
        disabled: function (disabled) {
            if (disabled !== undefined) {
                this.options.disabled = disabled
                this.element.prop("disabled", disabled)
                this.dom.tokenInput.find("input").prop("disabled", disabled)

                if (disabled === true) {
                    this.dom.container.addClass("disabled")
                    this.dom.tokenInput.hide()
                } else {
                    this.dom.container.removeClass("disabled")
                    this.dom.tokenInput.show()

                }
                return null
            }

            return this.options.disabled === true
        }
    })

    /**
     * @param {object} options
     * @returns {*}
     */
    $.fn.tokenInput = function (options) {
        return this.each(function () {
            // Prevent initialization TokenInput more then once
            if ($(this).data("tokenInput") !== undefined) {
                return
            }

            $(this).data("tokenInput", new TokenInput($(this), options))
        })
    }

    /**
     * @typedef {object} Options~TokenInput
     *
     * @property {string}                           locale
     * @property {object}                           trans
     * @property {string}                           trans.searchInputPlaceholder
     * @property {string}                           trans.noEnoughDataForSearch
     * @property {string}                           trans.searchInProgress
     * @property {string}                           trans.resultIsEmpty
     * @property {Item~TokenInput[]}                data
     * @property {object}                           ajax
     * @property {string|null}                      ajax.url
     * @property {string}                           ajax.method
     * @property {callback|object}                  ajax.data
     * @property {string}                           ajax.searchParam
     * @property {string}                           ajax.loadParam
     * @property {int}                              ajax.searchTimeout
     * @property {boolean}                          ajax.loadByIdentifier
     * @property {int}                              minChars
     * @property {?int}                             tokenLimit
     * @property {boolean}                          unique
     * @property {string}                           searchProperty
     * @property {string}                           valueProperty
     * @property {string}                           displayProperty
     * @property {boolean}                          highlightResultMatch
     * @property {string}                           highlightResultFormat
     * @property {string}                           resultFormat
     * @property {object}                           classes
     * @property {string}                           classes.core
     * @property {string}                           classes.tokenList
     * @property {string}                           classes.tokenItem
     * @property {string}                           classes.tokenItemSelected
     * @property {string}                           classes.tokenInput
     * @property {object[]}                         preloaded
     * @property {string}                           separator
     * @property {object}                           callback
     * @property {beforeAdd~TokenInput}             callback.beforeAdd
     * @property {beforeSearch~TokenInput}          callback.beforeSearch
     * @property {onAdd~TokenInput}                 callback.onAdd
     * @property {onRemove~TokenInput}              callback.onRemove
     * @property {formatSearchResultItem~TokenInput callback.formatSearchResultItem
     * @property {?boolean}                         disabled
     */

    /**
     * @typedef {object} Item~TokenInput
     */

    /**
     * @callback beforeAdd~TokenInput
     * @param {Item~TokenInput} item
     *
     * @returns {boolean}
     */

    /**
     * @callback beforeSearch~TokenInput
     * @param {string} value search value
     */

    /**
     * @callback onAdd~TokenInput
     * @param {Item~TokenInput} item
     */

    /**
     * @callback onRemove~TokenInput
     * @param {Item~TokenInput} item
     */

    /**
     * @callback formatSearchResultItem~TokenInput
     * @param {Item~TokenInput} item
     * @param {string} search search value
     */

    /**
     * @type {Options~TokenInput}
     */
    $.fn.tokenInput.options = {
        locale: "en",
        trans: {
            searchInputPlaceholder: "Type search text",
            noEnoughDataForSearch: "No enough character typed for search.",
            searchInProgress: "Searching...",
            resultIsEmpty: "Search result is empty.",
            ajaxError: "Something went wrong."
        },
        data: [],
        ajax: {
            url: null,
            method: "POST",
            data: {},
            searchParam: "s",
            loadParam: "l",
            searchTimeout: 200,
            loadByIdentifier: false
        },
        minChars: 1,
        tokenLimit: null,
        unique: false,
        searchProperty: "name",
        valueProperty: "id",
        displayProperty: "name",
        highlightResultMatch: true,
        highlightResultFormat: "<strong>$1</strong>",
        resultFormat: null,
        classes: {
            core: null,
            tokenList: null,
            tokenItem: null,
            tokenItemSelected: null,
            tokenInput: null
        },
        preloaded: [],
        separator: ",",
        callback: {
            beforeAdd: null,
            beforeSearch: null,
            onAdd: null,
            onRemove: null,
            formatSearchResultItem: null
        },
        disabled: null
    }
}(jQuery));

(function ($, undefined) {
    "use strict"

    $.extend($.fn.tokenInput.options, {
        classes: {
            core: "form-control",
            tokenList: "",
            tokenItem: "token-list-item",
            tokenItemSelected: "text-success",
            tokenInput: "token-list-input"
        }
    })
}(jQuery))



//////////////////
// WEBPACK FOOTER
// ./vendor/vi-kon/laravel-admin/src/resources/assets/js-tokeninput/js/jquery.token-input.js
// module id = 327
// module chunks = 0